<div style="margin-top:1px;" class="p-grid p-d-flex dialog-page">

      <div class="col-12 lg:col-12 p-12">
            <div class="surface-card border-round shadow-2 p-5">
                <div class="flex justify-content-between align-items-center border-bottom-1 pb-3 surface-border" *ngIf="!isInsert">
                    <span class="text-900 font-medium text-lg lg:text-xl"><i class="pi pi-shopping-cart text-xl mr-2"></i>{{item.code}} - {{item.name}}</span>
                </div>
                <div class="p-2 flex flex-column lg:flex-row flex-wrap lg:align-items-center" *ngIf="!isInsert">
                    <img [src]="'../../../../../assets/images/images-order/' + item.icon + ''" class="w-8rem h-8rem flex-shrink-0 mb-3" style=" background-color:orange;"/>
                    <div class="flex-auto lg:ml-3">
                        <div class="flex align-items-center justify-content-between mb-3">
                            <span class="text-600 font-medium">{{item.description}}</span>

                        </div>
                        <div class="text-600 text-lg mb-3">Valor Unitário: <span class="text-900 font-medium">{{((item.unitValueA ?? 0) + (item.unitValueB ?? 0) + (item.unitValueTaxA ?? 0) + (item.unitValueTaxB ?? 0)) | currency : 'BRL'}}</span></div>
                        <div class="flex flex-auto justify-content-between align-items-center" >
                            <div style="width: 120px;">
                                <p-inputNumber [showButtons]="true" buttonLayout="horizontal" spinnerMode="horizontal" min="0" inputStyleClass="w-2rem text-center p-0 border-none surface-50" [(ngModel)]="item.quantity"
                                class="border-none border-round" decrementButtonClass="surface-50 p-button-text text-600 hover:text-primary" incrementButtonClass="p-button-text surface-50 text-600 hover:text-primary py-1 px-1" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"></p-inputNumber>
                            </div>
                            <span class="text-600 cursor-pointer"><i class="pi pi-trash mr-2 ml-3"></i>Remover</span>
                        </div>
                    </div>
                </div>
                <div class="mt-2" *ngIf="isInsert" >
                    <div class="text-900 text-lg mb-3">Selecione o Serviço</div>
                    <sf-wo-order-service-dropdown [id]="item.id" (chosedItem)="reciverFeedbackOrderService($event)"></sf-wo-order-service-dropdown>
                </div>

                <div class="py-2 mt-3 border-bottom-1 surface-border">
                    <div class="flex justify-content-between align-items-center mb-3">
                        <span class="text-900">Subtotal</span>
                        <span class="text-900 font-bold">{{((item.unitValueA ?? 0) + (item.unitValueB ?? 0)) * (item.quantity ?? 1) | currency : 'BRL'}}</span>
                    </div>
                    <div class="flex justify-content-between align-items-center mb-3">
                        <span class="text-900">Taxas Cartorais</span>
                        <span class="text-900 font-bold">{{((item.unitValueTaxA ?? 0) + (item.unitValueTaxB ?? 0)) * (item.quantity ?? 1) | currency : 'BRL'}}</span>
                    </div>
                    <div class="flex justify-content-between align-items-center mb-3">
                        <span class="text-900">Taxa Operacional (valor unitário): {{item.unitValueTaxApp| currency : 'BRL'}}</span>
                        <span class="text-900 font-bold">{{(item.unitValueTaxApp ?? 0) * (item.quantity ?? 1) | currency : 'BRL'}}</span>
                    </div>

                    <div class="flex justify-content-between align-items-center mb-3">
                        <span class="text-900">Desconto Valor (R$)</span>
                        <div style="width: 150px;">
                            <p-inputNumber
                                [showButtons]="true"
                                buttonLayout="horizontal"
                                spinnerMode="horizontal"
                                min="0"
                                inputStyleClass="w-2rem text-center p-0 border-none surface-50"
                                [(ngModel)]="item.discountValue"
                                class="border-none border-round text-900 font-bold"
                                decrementButtonClass="surface-50 p-button-text text-600 hover:text-primary"
                                incrementButtonClass="p-button-text surface-50 text-600 hover:text-primary py-1 px-1"
                                incrementButtonIcon="pi pi-plus"
                                decrementButtonIcon="pi pi-minus"
                                [disabled]="!canUpdate"
                                [minFractionDigits]="2"
                                (onInput)="discountCalcule('valor', (item.quantity ?? 1) * ((item.unitValueA ?? 0) + (item.unitValueB ?? 0) + (item.unitValueTaxA ?? 0) + (item.unitValueTaxB ?? 0) + (item.unitValueTaxApp ?? 0)))">
                            </p-inputNumber>
                        </div>
                    </div>

                    <div class="flex justify-content-between align-items-center mb-3">
                        <span class="text-900">Desconto Percentual (%)</span>
                        <div style="width: 150px;">
                            <p-inputNumber
                                [showButtons]="true"
                                buttonLayout="horizontal"
                                spinnerMode="horizontal"
                                min="0"
                                inputStyleClass="w-2rem text-center p-0 border-none surface-50"
                                [(ngModel)]="item.discountPercent"
                                class="border-none border-round text-900 font-bold"
                                decrementButtonClass="surface-50 p-button-text text-900 hover:text-primary"
                                incrementButtonClass="p-button-text surface-50 text-900 hover:text-primary py-1 px-1"
                                incrementButtonIcon="pi pi-plus"
                                decrementButtonIcon="pi pi-minus"
                                [disabled]="!canUpdate"
                                [minFractionDigits]="2"
                                (onInput)="discountCalcule('porc', (item.quantity ?? 1) * ((item.unitValueA ?? 0) + (item.unitValueB ?? 0) + (item.unitValueTaxA ?? 0) + (item.unitValueTaxB ?? 0) + (item.unitValueTaxApp ?? 0)))">
                            </p-inputNumber>
                        </div>
                    </div>
                    <div class="flex justify-content-between align-items-center mb-3">
                        <span class="text-900">Total</span>
                        <!-- <span class="text-900 font-bold">{{(item.quantity ?? 1) * ((item.unitValueA ?? 0) + (item.unitValueB ?? 0) + (item.unitValueTaxA ?? 0) + (item.unitValueTaxB ?? 0) + (item.unitValueTaxApp ?? 0) - (item.discountValue ?? 0)) * (item.quantity ?? 1) | currency : 'BRL'}}</span> -->
                        <span class="text-900 font-bold">{{(item.finalValue ?? 0) | currency : 'BRL'}}</span>
                    </div>
                </div>
            </div>
        </div>

</div>

<div style="float: right; display: flex; align-items: flex-end; gap: 8px;">
    <button pButton pRipple
        icon="pi pi-times"
        style="width: 150px; margin: 3px;"
        class="text-xl font-semibold p-button-outlined"
        size="large"
        [label]="'button.cancel' | translate"
        (click)="hideDialog();" >
    </button>
    <button pButton pRipple
        icon="pi pi-save"
        style="width: 150px; margin: 3px;"
        class="text-xl font-semibold ml-3"
        [label]="'button.save' | translate"
        (click)="saveItem();" >
    </button>
</div>
